import { Flex, Spin } from "antd";
import NoBoardFounds from "../../ScrumBoard/Board/BoardNotFound/BoardNotFound";

export default function LoadData({ loading, data, children, type, height }) {

    // loading: Main page loader without content
    const dataType = typeof data;

    return (
        <div style={{ width: "100%", height: height ? height : "100%", display: "flex", flexDirection: "column" }}>
            <Spin spinning={Boolean(loading)} className="outer-load-class" wrapperClassName="inner-load-container" style={{height: "100%"}}>
                {dataType === "object" ?
                    data && Object.keys(data).length > 0 ?
                            children
                        : <NoBoardFounds section={"No Board"} style={{ height: type === "card" ? "inherit" : "calc(100vh - 255px)" }} /> :
                    data?.length > 0 ?
                            children
                        : <NoBoardFounds section={"No Board"} style={{ height: type === "card" ? "inherit" : "calc(100vh - 255px)" }} />}
            </Spin>
        </div>
    );
}